module.exports = __webpack_public_path__ + "img/4.e81746db.png";